import axios from "axios";

// Backend for the University of Larkano website. Only the career application
// submission (CAREER_APPLY) is wired to it today — every other page still
// reads local JSON via ApiProvider's resolveLocal(). See the reference block
// at the bottom of ApiProvider.js for the RPC-style convention the rest of
// the endpoints will eventually follow (POST <baseURL><FUNCTION_NAME>).
const axiosInstance = axios.create({
  baseURL: "https://dash-backend-gamma.vercel.app/",
});

export default axiosInstance;
